var scope_0 = require('/Users/hostjane/hosting/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/046588e49e18d7fb360814c9d977ab80.js').default;
var scope_1 = require('/Users/hostjane/hosting/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    